class Alert {
    show(type, header, body, footer, showClose = true) {
        if (typeof header == "undefined") {
            header = "";
        }
        if (typeof body == "undefined") {
            body = "";
        }
        if (typeof footer == "undefined") {
            footer = "";
        }

        let html = '<div class="alert-mask"><div class="alert-wrapper"><div class="alert-container">';
        if (showClose) {
            html += '<button type="button" class="close alert-close can-close" aria-label="Close"></button>';
        }
        if (header.length) {
            html += '<div class="alert-header"></div>';
        }

        if (body.length) {
            html += '<div class="alert-body"></div>';
        }

        if (footer.length) {
            html += '<div class="alert-footer"></div>';
        }

        html += '</div></div></div>';

        let alertBox = document.createElement("alert");
        alertBox.classList.add(type);
        alertBox.innerHTML = html;
        alertBox.mask = alertBox.querySelector(".alert-mask");
        alertBox.header = alertBox.querySelector(".alert-header");
        alertBox.body = alertBox.querySelector(".alert-body");
        alertBox.footer = alertBox.querySelector(".alert-footer");
        alertBox.mask.addEventListener("click", function (e) {
            if (e.target.classList.contains("can-close") || e.target.classList.contains("alert-mask")) {
                alertBox.close();
            }
        });
        alertBox.open = function (header, body, footer) {
            alertBox.isOpen = true;
            if (header.length) {
                let abh = $(alertBox.header);
                if (abh) {
                    abh.html(header);
                }
            }
            if (body.length) {
                let abb = $(alertBox.body);
                if (abb) {
                    abb.html(body);
                }
            }
            if (footer.length) {
                let abf = $(alertBox.footer);
                if (abf) {
                    abf.html(footer);
                }
            }
            alertBox.mask.style.opacity = "1";
        };
        alertBox.close = function () {
            alertBox.mask.style.opacity = "0";
            setTimeout(() => {
                app.util.removeElement(alertBox);
            }, 300);
        };
        document.body.appendChild(alertBox);
        alertBox.focus();
        alertBox.open(header, body, footer);
        return alertBox;
    }

    prompt(header, message, footer) {
        return app.alert.show("prompt", header, message, footer);
    }

    error(header, message, footer) {
        app.alert.show("danger", header, message, footer);
    }

    warning(header, message, footer) {
        app.alert.show("warning", header, message, footer);
    }

    success(header, message, footer) {
        app.alert.show("success", header, message, footer);
    }

    overlay(imgSrc) {
        app.alert.show("overlay", "", "<img src='" + imgSrc + "'>");
    }

    info(header, message, footer) {
        app.alert.show("info", header, message, footer);
    }

    code(header, message, footer) {
        app.alert.show("code", header, "<pre>" + message + "</pre>", footer);
    }

    dialog(header, message, positiveText, onPositive, negativeText, onNegative) {
        if (!negativeText) {
            negativeText = "x";
        }
        let dialog = app.alert.show("info", header, message, "<div class='dialog_options d-sm-flex flex-sm-row-reverse justify-content-around px-3'><div class='btn btn-green btn-block-xs-only can-close dialog-positive'>" + positiveText + "</div><div class='btn btn-info btn-block-xs-only cancel can-close dialog-negative'>" + negativeText + "</div></div>", false);
        $(dialog.footer).find(".dialog-positive").on("click", onPositive);
        if (onNegative) {
            $(dialog.footer).find(".dialog-negative").on("click", onNegative);
        }

        return dialog;
    }

    close() {
        let alerts = document.querySelectorAll("alert");
        if (alerts.length) {
            alerts[alerts.length - 1].close();
        }
    }
}